/**
 * Client-side header preview. SPEC-0001 step 2.
 *
 * Parses ONLY the header row, so the user sees their own columns immediately
 * without waiting on an upload. This is a UX affordance and is never the
 * source of truth — the server re-parses the whole file authoritatively.
 */
import Papa from 'papaparse';

export function readHeaderRow(file: File): Promise<string[]> {
	return new Promise((resolve, reject) => {
		Papa.parse<string[]>(file, {
			preview: 1,
			skipEmptyLines: true,
			complete: (result) => resolve((result.data[0] ?? []).map((h) => h.trim())),
			error: (error: Error) => reject(error),
		});
	});
}
